"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _colors = _interopRequireDefault(require("../../theme/colors"));
var _Text = _interopRequireDefault(require("../Text"));
var _Button = _interopRequireDefault(require("../Button"));
var _Close = _interopRequireDefault(require("@mui/icons-material/Close"));
var _i18n = _interopRequireDefault(require("../../localization/i18n"));
var _tokens = _interopRequireDefault(require("../../localization/tokens"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * @param children
 * @param open
 * @param medium
 * @param large
 * @param onClose
 * @param primaryButton
 * @param secondaryButton
 * @param title
 * @param loading
 * @param style
 * @returns {JSX.Element|null}
 * @constructor
 */
var NewModal = function NewModal(_ref) {
  var children = _ref.children,
    open = _ref.open,
    medium = _ref.medium,
    large = _ref.large,
    onClose = _ref.onClose,
    primaryButton = _ref.primaryButton,
    secondaryButton = _ref.secondaryButton,
    title = _ref.title,
    loading = _ref.loading,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style;
  var styles = {
    closeIcon: {
      color: _colors["default"].darkGrey,
      cursor: 'pointer',
      '&:hover': {
        backgroundColor: 'rgba(0,0,0,0.1)' /* Black w/ opacity */
      }
    },
    backdrop: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: '100%',
      height: '100%',
      zIndex: 1000,
      position: 'fixed',
      left: 0,
      top: 0,
      overflow: 'auto',
      backgroundColor: 'rgba(0, 0, 0, 0.5)' /* Black w/ opacity */
    },
    modal: _objectSpread({
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: '#FFFFFF',
      borderRadius: 10,
      boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
      padding: "30px 45px 35px 40px",
      width: large ? '80%' : medium ? '50%' : '20%',
      minWidth: 500,
      minHeight: 160,
      maxHeight: '85%',
      overflow: 'auto',
      maxWidth: large ? "1950px" : medium ? "1000px" : "800px"
    }, style),
    titleBlock: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center'
    },
    contentBlock: {
      display: 'flex',
      flex: 1,
      flexDirection: 'column',
      paddingTop: "20px",
      paddingBottom: "20px"
    },
    buttonBlock: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-end'
    },
    closeButton: {
      marginRight: "2px",
      color: _colors["default"].darkGrey,
      '&:hover': {
        backgroundColor: 'rgba(0, 0, 0, 0.1)' /* Black w/ opacity */
      }
    }
  };
  if (!open) {
    return null;
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.backdrop
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.modal
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.titleBlock
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    large: true,
    bold: true,
    customStyle: {
      fontSize: "24px"
    }
  }, title), onClose && /*#__PURE__*/_react["default"].createElement(_Close["default"], {
    onClick: onClose,
    sx: styles.closeIcon
  })), /*#__PURE__*/_react["default"].createElement("div", {
    id: "modalContentBlock",
    style: styles.contentBlock
  }, children), /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.buttonBlock
  }, onClose && /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    transparent: true,
    color: "primary",
    onClick: onClose,
    customStyle: styles.closeButton
  }, _i18n["default"].t(_tokens["default"].buttons.close)), secondaryButton && /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    primary: true,
    icon: secondaryButton.icon,
    color: secondaryButton.color || 'primary',
    onClick: secondaryButton.onClick
  }, secondaryButton.label), primaryButton && /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    primary: true,
    icon: primaryButton.icon,
    color: primaryButton.color || 'primary',
    onClick: primaryButton.onClick
  }, primaryButton.label)), loading.isLoading && loading.type === 'modal' && /*#__PURE__*/_react["default"].createElement(Loader, {
    isModal: true
  })));
};
var _default = exports["default"] = NewModal;